<template lang="pug">
.report-root
    general-title(
        title="网站测速",
        description="主要衡量网站的速度，评估网站的网页加载时间，并提出相关的网站速度优化建议",
        pos="right"
    )

    ul.tab
        li.tab-item(v-for="tab in tabData", :key="tab.id")
            a.tabview-btn(
                :class="{active: curTabId === tab.id}",
                @click="curTabId = tab.id"
            ) {{tab.name}}
    div.container
        span.label(v-show="curTabId === 'rate'") 需诊断的网站URL
        span.label(v-show="curTabId === 'speed'") 需测速的网站URL

        v-input(v-model="inputText", placeholder="请输入 URL", @keyup.enter="submit")

        button.btn.btn-primary.btn-big(@click="submit") 测一下
</template>

<script>
import { stringify } from 'query-string';
const OPEN_URL = 'http://ce.cloud.360.cn/task';
const URL_RE = /^((https?:)?\/\/)?[0-9a-zA-Z]+[0-9a-zA-Z\.-]*\.[a-zA-Z]+/;
export default {
    data() {
        let data = [{
            id: 'speed',
            name: '网站测速',
            params: {
                type:'get',
                src: '360statistic'
            }
        }, {
            id: 'rate',
            name: '网站评分',
            params: {
                type: 'harys',
                src: '360statistic'
            }
        }];

        return {
            tabData: data,
            curTabId: 'speed',
            inputText: this.$store.state.currentDomain.domain || ''
        };
    },

    computed: {
        currentDomain() {
            return this.$store.state.currentDomain;
        }
    },
    watch: {
        currentDomain(newVal) {
            this.inputText = newVal && newVal.domain || '';
        }
    },
    methods: {
        submit() {
            let text = _.trim(this.inputText);
            let errmsg = '';
    
            if (!text) {
                errmsg = '内容不能为空';
            } else if (!URL_RE.test(text)) {
                errmsg = '内容格式不正确';
            } else if (text.length > 1000) {
                errmsg = 'URL 过长';
            }
            if (errmsg.length) {
                this.$Modal.warn(errmsg);
            } else {
                let { params } = _.find(this.tabData, {id: this.curTabId});
                let qs = stringify(_.extend({}, params, { domain: text }));
                window.open(`${OPEN_URL}?${qs}`);
            }
        }
    }
};
</script>

<style scoped>
.container {
    padding: 20px;
}
.label {
    margin-right: 12px;
}
</style>
 



// WEBPACK FOOTER //
// speed.vue?00e45530